import { render, staticRenderFns } from "./FooterInside.vue?vue&type=template&id=8dd3cd98&scoped=true&"
import script from "./FooterInside.vue?vue&type=script&lang=js&"
export * from "./FooterInside.vue?vue&type=script&lang=js&"
import style0 from "./FooterInside.vue?vue&type=style&index=0&id=8dd3cd98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd3cd98",
  null
  
)

export default component.exports